import { Candidate, ChatMessage, ChatMessageMetaData, Resume } from 'types/types';

const emptyMetadata: ChatMessageMetaData = {
  model: 'qwen2.5',
  temperature: 0,
  maxTokens: 0,
  topP: 0,
  frequencyPenalty: 0,
  presencePenalty: 0,
  stopSequences: [],
  usage: {
    evalCount: 0,
    evalDuration: 0,
    promptEvalCount: 0,
    promptEvalDuration: 0,
  },
};

const defaultMessage: ChatMessage = {
  status: 'done',
  type: 'text',
  sessionId: '',
  timestamp: new Date(),
  content: '',
  role: 'user',
  metadata: emptyMetadata,
};

function possessive(name: string): string {
  return name.endsWith('s') ? `${name}'` : `${name}'s`;
}

function buildWelcomeMessage(
  isMobile: boolean,
  chatSessionId: string | undefined,
  selectedCandidate: Candidate | null,
  resume: Resume | null
): ChatMessage {
  if (!selectedCandidate) {
    return { ...defaultMessage, sessionId: chatSessionId || '', role: 'information' };
  }

  const mobileWelcomeContent = resume
    ? `Ask about ${possessive(selectedCandidate.firstName)} fit for ${resume.job?.company} ${
        resume.job?.title
      }. Use the Resume tab for the full document.`
    : `Ask about ${possessive(selectedCandidate.firstName)} skills, experience, and strengths.`;

  const welcomeMessage: ChatMessage = {
    ...defaultMessage,
    sessionId: chatSessionId || '',
    role: 'information',
    content: isMobile
      ? mobileWelcomeContent
      : `Welcome to the Backstory Chat about ${selectedCandidate.fullName}.`,
  };

  if (!isMobile && resume) {
    welcomeMessage.content =
      `Welcome to Backstory Chat, analyzing ${possessive(
        selectedCandidate.fullName
      )} work experience ` + `against the ${resume.job?.company} ${resume.job?.title} position.`;
  }
  if (!isMobile) {
    welcomeMessage.content += `\n\nSelect from the suggested questions or enter your own to learn more about ${possessive(
      selectedCandidate.firstName
    )} skills.`;
  }
  return welcomeMessage;
}

export { buildWelcomeMessage, defaultMessage, emptyMetadata, possessive };
